import { ToastContainer } from "react-toastify";
import { CheckCircleIcon, WarningErrorIcon } from "vega-icons";

import { isTruthy } from "@vega-core/utils/isTruthy";

import { CloseButton } from "../Buttons/CloseButton/CloseButton";

import {
  type Props as ToastProps,
  type ToastTransition,
  type ToastVariant,
} from "./types";

const getToastIcon = (variant: ToastVariant) => {
  if (variant === "destructive") {
    return <WarningErrorIcon className="text-text/negative" />;
  }

  if (variant === "success") {
    return <CheckCircleIcon className="text-text/positive" />;
  }

  return null;
};

const Toast = ({
  title,
  description,
  children,
  variant = "default",
  closeToast,
}: ToastProps) => (
  <div className="pr-7" data-testid={`toast-${variant}`}>
    <div className="flex gap-2 text-text/primary body-base-semibold items-center">
      {getToastIcon(variant)}
      {title ?? null}
    </div>
    {isTruthy(description) && (
      <div className="text-text/primary body-small-regular mt-1">
        {description}
      </div>
    )}
    {children}
    <div className="absolute right-2 top-2 rounded-xl p-1 text-text/primary focus:outline-none focus:ring-2 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600">
      <CloseButton onClick={closeToast as VoidFunction} />
    </div>
  </div>
);

export type { ToastProps, ToastTransition };
export { Toast, ToastContainer };
